import type { JSX } from 'react';
import { DateTime } from '@ksyos/date-time';
import { FormSection } from '@ksyos/design-system';
import type { BariPostEnrollmentDataV1 } from '@common/validation/customControls/bariPost/bariPostEnrollment/v1/bariPostEnrollmentDataV1';
import { ProcessActivityAssetsDropzone } from '@frontend/components/pages/episodeCategory/customControls/processActivityAssets/ProcessActivityAssetsDropzone';
import { useProcessActivityEditContext } from '@frontend/utils';
import {
    BooleanRadioGroupFormGroup,
    DateInputFormGroup,
    TextAreaFormGroup,
} from '../../../processActivityFormGroupFields';
import { BariPostEnrollmentOperatie } from '../BariPostEnrollmentOperatie';

/**
 * @deprecated CS-20926 Use `BariPostEnrollmentEditV2` instead
 */
export function BariPostEnrollmentEditV1(): JSX.Element {
    const { data, onChange } = useProcessActivityEditContext<BariPostEnrollmentDataV1>();

    return (
        <>
            <BariPostEnrollmentOperatie />
            <FormSection title="Labwaarden">
                <DateInputFormGroup
                    fieldKey="datum_lab_geprikt"
                    label="Datum lab geprikt"
                    maxDate={DateTime.now().format()}
                />
                <ProcessActivityAssetsDropzone
                    errorText="Voeg alsjeblieft bestanden met labwaarden toe"
                    label="Pre-operatieve labwaarden"
                />
                <BooleanRadioGroupFormGroup
                    fieldKey="bijzonderheden_labwaarden"
                    isRequired={true}
                    label="Bijzonderheden labwaarden"
                    onChange={async (checked) =>
                        onChange(
                            {
                                bijzonderheden_labwaarden: checked,
                                bijzonderheden_labwaarden_omschrijving: null,
                            },
                            'bijzonderheden_labwaarden'
                        )
                    }
                    type="radio"
                />
                {data.bijzonderheden_labwaarden && (
                    <TextAreaFormGroup
                        fieldKey="bijzonderheden_labwaarden_omschrijving"
                        isRequired={true}
                        label="Omschrijving bijzonderheden"
                        placeholder="In de labwaarden staat..."
                    />
                )}
            </FormSection>
        </>
    );
}
